<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted(){
    window.parent['swichPage'] = () =>{
      this.$store.commit('environmentchange_2')
    }
    window.parent['changepage']= () =>{
      this.$store.commit('pageshowchange')
    }
  },
  methods:{

  }
}
</script>
<style>
@font-face {
  font-family: 'pm';
  src: url('@/assets/庞门正道标题体.TTF');
}
body,html{
  overflow: hidden;
}
*{
  margin: 0;
  padding: 0;
  list-style: none;
}
#app{
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
/* .el-slider__bar {
    background-color: #649cff !important;
}
.el-slider__button {
    border: 2px solid #649cff !important;
}
.el-slider__runway.disabled .el-slider__bar {
    background-color: #c0c4cc !important;
}
.el-slider__runway.disabled .el-slider__button {
    border-color: #c0c4cc !important;
} */
.bscroll-vertical-scrollbar{
  display: none !important;
}
.custom-vertical-scrollbar{
   position: absolute;
    top: 50%;
    right: .0625rem;
    height: 6.25rem;
    width: .4375rem;
    border-radius: .375rem;
    transform: translateY(-50%) translateZ(0);
    background-color: rgb(200, 200, 200, 0.3);
    z-index: 10;
}
   
.custom-vertical-indicator{
  width: 100%;
  height: 1.25rem;
  border-radius: .375rem;
  background-color: #ffffff;
}
</style>
